import TitleUnderline from '@/molecules/titles/TitleUnderline';

const HrRenderer = () => <TitleUnderline className="my-2" />;

export default HrRenderer;
